import React from 'react';
import { Modal } from '~/components';
import { FormGroup, FormSelect } from '~/components/form';
import { MdClose } from 'react-icons/md';
import { useSearchHistory } from './context';

const FilterModal = ({ setOpen, isOpen = false }) => {

    const { filters, applyFilters, clearFilters, fieldActions } = useSearchHistory();

    return (
        <Modal isModalOpen={isOpen} preventScroll className='rounded-md bg-white'>
            <section className='w-full h-full flex flex-col items-stretch justify-start'>
                <header className="border-b-2 text-sm flex items-center justify-between py-2 px-6">
                    <p className="font-semibold">Filters</p>
                    <button 
                        className="py-2 rounded-full"
                        onClick={() => setOpen(false)}
                    >
                        <MdClose size="1em" />
                    </button>
                </header>
                <div className='flex items-center justify-center flex-1 p-6'>
                    <div className='grid grid-cols-11 gap-y-4'>
                        <FormGroup
                            inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                            labelClassName='text-sm'
                            groupClassName='col-span-5'
                            label='Your File No.'
                            value={filters.filenumber}
                            path='filenumber'
                            {...fieldActions}
                        />
                        <span className='col-span-1' />
                        <FormGroup
                            inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                            labelClassName='text-sm'
                            groupClassName='col-span-5'
                            label='Owner Name'
                            value={filters.ownerName}
                            path='ownerName'
                            {...fieldActions}
                        />
                        <FormGroup
                            inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                            datePickerClasses='w-full'
                            labelClassName='text-sm'
                            groupClassName='col-span-5'
                            type='date-picker'
                            dateFormat='MM/dd/yyyy'
                            label='Submission Date Start'
                            path='submissionStart'
                            value={filters.submissionStart}
                            {...fieldActions}
                        />
                        <div className='col-span-1 flex justify-center'>
                            <span className='h-8 mt-auto text-sm'>
                                to
                            </span>
                        </div>
                        <FormGroup
                            inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                            datePickerClasses='w-full'
                            labelClassName='text-sm'
                            groupClassName='col-span-5'
                            type='date-picker'
                            dateFormat='MM/dd/yyyy'
                            label='Submission Date End'
                            path='submissionEnd'
                            value={filters.submissionEnd}
                            {...fieldActions}
                        />
                        <FormGroup
                            inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                            labelClassName='text-sm'
                            groupClassName='col-span-5'
                            label='Street Address'
                            value={filters.address}
                            path='address'
                            {...fieldActions}
                        />
                        <span className='col-span-1' />
                        <FormGroup
                            inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                            labelClassName='text-sm'
                            groupClassName='col-span-5'
                            label='County'
                            value={filters.county}
                            path='county'
                            {...fieldActions}
                        />
                        <FormSelect 
                            options={filters.statusOptions}
                            isMulti
                            inputClassName='w-full mt-2 border-1 border-gray-200 rounded bg-gray-50'
                            labelClassName='text-sm'
                            groupClassName='col-span-5'
                            label='Status'
                            path='status'
                            value={filters.status}
                            {...fieldActions}
                        />
                        <div className='col-span-11 flex items-center justify-end text-xs'>
                            <button 
                                className='py-2 px-4 rounded-full border mr-2 focus:outline-none'
                                onClick={clearFilters}
                            >
                                Clear Filters
                            </button>
                            <button 
                                className='py-2 px-4 rounded-full bg-blue-50 text-white focus:outline-none'
                                onClick={applyFilters}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </Modal>
    );
};

export default FilterModal;